import "./CompanyPreview.scss"

import { Highlightable, Themeable } from "@/app/types"
import { CompanyBase } from "@/entities/company/company.types"
import { classWithModifiers } from "@/utils/common"

import CompanyAvatar from "../Avatar/CompanyAvatar"

interface CompanyPreviewProps extends CompanyBase, Partial<Highlightable>, Themeable {
  active?: boolean
  size?: "small" | "big"
  companyAvatarBackgroundColor?: string
  companyAvatarLetterColor?: string
}

function CompanyPreview(props: CompanyPreviewProps) {

  return (
    <div className={classWithModifiers("company-preview", props.active && "active", props.theme, props.size)}>
      <CompanyAvatar name={props.title} src={props.logo} backgroundColor={props.companyAvatarBackgroundColor} letterColor={props.companyAvatarLetterColor} />
      <div className="company-preview__title">{props.highlight?.(props.title) ?? props.title}</div>
    </div>
  )
}

export default CompanyPreview
